import { render, staticRenderFns } from "./yisheng.vue?vue&type=template&id=b22b27ba&scoped=true"
import script from "./yisheng.vue?vue&type=script&lang=js"
export * from "./yisheng.vue?vue&type=script&lang=js"
import style0 from "./yisheng.vue?vue&type=style&index=0&id=b22b27ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22b27ba",
  null
  
)

export default component.exports